export const FEATURES = {
	BASIC: {
		DASHBOARD: {
			DISABLE_CONTEXT_SHARE: true,
			DISABLE_CONTEXT_RUN_NOW: true /* On failure case */,
			DISABLE_SHARE_WITH_ME_TAB: true,
			DISABLE_STD_USER_PERSONA: true
		},
		TEMPLATE_PAGE: {
			SHOW_CHARTER_TAG_ON_CARD: true,
			PREVIEW_ATTRIBUTE_ONLY: true,
			DISABLE_QUICK_REPORT: true,
			SHOW_PREVIEW_BUTTON: true,
			SHOW_TEMPLATE_NAME: true,
			HIDE_ATTRIBUTE_FILTER: true,
			DISABLE_CUSTOM_ATTRIBUTE: true,
			DISABLE_CUSTOMIZE: true,
			SHOW_CUSTOM_DATASET: true
		},
		PREVIEW_PAGE: {
			DISABLE_PREVIEW: true,
			LIMIT_HISTORICAL_DATA_VIEWING: true,
			DISABLE_ATTRIBUTE: true,
			DISABLE_GREGORIAN_CALENDAR: true,
			DISABLE_CREATE_COPY: false,
			DISABLE_CUSTOM_ATTRIBUTE: true /* Accordion */,
			ROW_COUNT_PARAM_REQUIRED: true /* To append param in rowCount url */,
			SHOW_SAMPLE_FIRST_ROW: true,
			HELP: {
				SHOW_CONTACT_SALES: true,
				SHOW_LUMINATE_CHARTER: true,
				SHOW_TRAINING: false,
				BASIC_LINK_ITEMS: true
			},
			ENABLE_PINNED_ATTRIBUTE: true
		},
		REPORT_SETTINGS_PAGE: {
			HIDE_REPORT_SHARING: true,
			SCHEDULE_TODAY: true,
			DISABLE_LATER_TIME: true,
			DISABLE_ROW_COUNT: true,
			CAN_USER_CREATE_REPORT_CHECK: true,
			DYNAMIC_SCHEDULE_AVAILABLE: false
		}
	},
	CHARTER: {
		DASHBOARD: {
			DISABLE_CONTEXT_SHARE: false,
			DISABLE_CONTEXT_RUN_NOW: false /* On failure case */,
			DISABLE_SHARE_WITH_ME_TAB: false,
			DISABLE_STD_USER_PERSONA: false
		},
		TEMPLATE_PAGE: {
			SHOW_CHARTER_TAG_ON_CARD: false,
			PREVIEW_ATTRIBUTE_ONLY: false,
			DISABLE_QUICK_REPORT: false,
			SHOW_PREVIEW_BUTTON: false,
			SHOW_TEMPLATE_NAME: false,
			HIDE_ATTRIBUTE_FILTER: false,
			DISABLE_CUSTOM_ATTRIBUTE: false,
			DISABLE_CUSTOMIZE: false,
			SHOW_CUSTOM_DATASET: true
		},
		PREVIEW_PAGE: {
			DISABLE_PREVIEW: false,
			LIMIT_HISTORICAL_DATA_VIEWING: false,
			DISABLE_ATTRIBUTE: true,
			DISABLE_GREGORIAN_CALENDAR: false,
			DISABLE_CREATE_COPY: false,
			DISABLE_CUSTOM_ATTRIBUTE: false /* Accordion */,
			ROW_COUNT_PARAM_REQUIRED: false /* To append param in rowCount url */,
			SHOW_SAMPLE_FIRST_ROW: false,
			DISABLE_SAVE: false,
			HELP: {
				SHOW_CONTACT_SALES: false,
				SHOW_LUMINATE_CHARTER: false,
				SHOW_TRAINING: true,
				BASIC_LINK_ITEMS: false
			},
			ENABLE_PINNED_ATTRIBUTE: true
		},
		REPORT_SETTINGS_PAGE: {
			HIDE_REPORT_SHARING: false,
			SCHEDULE_TODAY: false,
			DISABLE_LATER_TIME: false,
			DISABLE_ROW_COUNT: false,
			CAN_USER_CREATE_REPORT_CHECK: false,
			DYNAMIC_SCHEDULE_AVAILABLE: true
		}
	}
};
